import { render } from "./RatingEditor.vue?vue&type=template&id=3d9b46ea"
import script from "./RatingEditor.vue?vue&type=script&lang=js"
export * from "./RatingEditor.vue?vue&type=script&lang=js"

import "./RatingEditor.vue?vue&type=style&index=0&id=3d9b46ea&lang=css"
script.render = render

export default script